import { Helmet } from "react-helmet";

type Props = {
  title: string;
};

export const PageTitle = (props: Props) => {
  return (
    <Helmet>
      <title>{props.title}</title>
    </Helmet>
  );
};
